import {
  FETCH_ORDER_BY_ORDER_NUMBER,
  FETCH_ORDER_BY_ORDER_NUMBER_FAILURE,
  FETCH_ORDER_BY_ORDER_NUMBER_SUCCESS,
  RESET_TRACKED_ORDER,
} from "./trackOrderTypes";
export const fetchingState = {
  inProgress: "inProgress",
  success: "Success",
  failure: "Failure",
};
const initialState = {
  orderByOrderNumber: {
    fetchingStatus: {
      state: undefined,
    },
    order: undefined,
    error: undefined,
  },
};

const trackOrderReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ORDER_BY_ORDER_NUMBER:
      return {
        ...state,
        orderByOrderNumber: {
          ...state.orderByOrderNumber,
          fetchingStatus: {
            state: fetchingState.inProgress,
          },
        },
      };
    case FETCH_ORDER_BY_ORDER_NUMBER_SUCCESS:
      return {
        ...state,
        orderByOrderNumber: {
          ...state.orderByOrderNumber,
          fetchingStatus: { state: fetchingState.success },
          order: action.payload,
        },
      };
    case FETCH_ORDER_BY_ORDER_NUMBER_FAILURE:
      return {
        ...state,
        orderByOrderNumber: {
          ...state.orderByOrderNumber,
          fetchingStatus: {
            state: fetchingState.failure,
          },
          order: undefined,
          error: action.payload,
        },
      };
    case RESET_TRACKED_ORDER: {
      return {
        ...state,
        orderByOrderNumber: {
          ...initialState.orderByOrderNumber,
        },
      };
    }
    default:
      return {
        ...state,
      };
  }
};

export default trackOrderReducer;
